import { render } from "./view-kv-customer-vers.vue?vue&type=template&id=99192f68"
import script from "./view-kv-customer-vers.vue?vue&type=script&lang=js"
export * from "./view-kv-customer-vers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/view-kv-customer-vers/view-kv-customer-vers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "99192f68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99192f68', __exports__)) {
    api.reload('99192f68', __exports__)
  }
  
  module.hot.accept("./view-kv-customer-vers.vue?vue&type=template&id=99192f68", () => {
    api.rerender('99192f68', render)
  })

}


export default __exports__